<style scoped>
.group-title {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    text-align: center;
}
.group-title::before,
.group-title::after {
    content: '';
    @apply block my-4;
    @apply border-b border-gray-100 border-dotted;
    flex: 1;
    height: 0;
    position: relative;
    top: 2px;
}
.group-title::before {
    @apply mr-4;
}
.group-title::after {
    @apply ml-4;
}
</style>

<template>
    <div>
        <breadcrumb class="mt-4" :links="[{ msg: 'credit.point.history' }]" />

        <div class="my-8 flex justify-center" v-if="loading">
            <spinner />
        </div>

        <div v-else-if="hasCrdtPntHist" class="content-box-wrapper">
            <!-- <h3 class="section-title mb-4">
                {{ $t('credit.point.history') }}
            </h3> -->

            <div class="flex flex-wrap items-center">
                <div class="text-2xl font-bold">
                    {{ $t('credit.point.history.greet', userFullName) }}
                </div>
                <howToGetTcoinModalButton
                    v-if="enableReferral"
                    class="ml-auto"
                    :msg="'如何獲得更多T-Coins'"
                    :btnClass="
                        'text-secondary underline hover:text-red focus:outline-none'
                    "
                />
            </div>

            <div class="w-full flex flex-col justify-center my-4">
                <div class="mx-auto text-2xl font-bold">
                    您現時的T-Coins結餘
                </div>
                <div
                    class="mx-auto flex justify-center items-center text-4xl font-bold mt-4 px-8 bg-primary rounded-lg text-white"
                >
                    <div class="icon w-10 h-10">
                        <tryhalaCoinSvg />
                    </div>
                    {{ crdtPntBal }}
                </div>
            </div>

            <table class="block w-full max-w-full mx-auto mt-4">
                <thead class="hidden lg:block text-lg">
                    <tr class="flex w-full">
                        <th class="block w-64 px-4 py-2 font-black">
                            {{ $t('common.date') }}
                        </th>
                        <th class="block flex-1 px-4 py-2 font-black">
                            {{ $t('credit.point.history.detail') }}
                        </th>
                        <th class="block w-32 px-4 py-2 font-black">
                            {{ $t('credit.point.delta') }}
                        </th>
                        <th class="block w-32 px-4 py-2 font-black">
                            {{ $t('credit.point.balance') }}
                        </th>
                    </tr>
                </thead>
                <tbody class="block w-full">
                    <div
                        v-for="(g, gi) in recordsInPageGroupByYearMonth"
                        :key="gi"
                        class="mb-12"
                    >
                        <div class="group-title mb-4">
                            {{ `${g.year}年${g.month + 1}月` }}
                        </div>
                        <tr
                            v-for="(h, hi) in g.list"
                            :key="hi"
                            class="block mx-2 p-2 border rounded border-gray-100 shadow mb-4 clearfix lg:flex lg:border-0 lg:rounded-none lg:p-0 lg:m-0 lg:shadow-none"
                            :class="{ 'lg:border-t-0': hi !== 0 }"
                        >
                            <td class="block lg:p-2 lg:w-64 lg:text-center">
                                {{
                                    h.crdtPntTxnDate
                                        | formatDate('dayOnlyDatetime')
                                }}
                            </td>
                            <td class="lg:p-2 lg:flex-1 lg:text-center">
                                <div class="inline-block lg:block">
                                    {{
                                        h.crdtPntTxnTypeSlctDesp
                                            ? $t(h.crdtPntTxnTypeSlctDesp)
                                            : ''
                                    }}
                                </div>
                                <router-link
                                    v-if="h.saleOrdTxnNum"
                                    tag="button"
                                    :to="
                                        `/account/orderHistory/${h.saleOrdTxnNum}`
                                    "
                                    class="inline-block underline text-blue"
                                >
                                    {{ h.saleOrdNum }}
                                </router-link>
                                <contentNewLine :value="h.crdtPntTxnExtrDesp" />
                            </td>
                            <td
                                class="flex content-center lg:block lg:p-2 lg:w-32 lg:text-center"
                            >
                                <div class="w-32 lg:hidden">
                                    <div class="flex justify-start">
                                        <tryhalaCoinSvg
                                            class="w-6 h-6 text-primary fill-current"
                                        />
                                        <div>
                                            {{ $t('credit.point.delta') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="font-bold lg:font-normal">
                                    {{
                                        (h.crdtPntTxnQty > 0
                                            ? '+' + h.crdtPntTxnQty
                                            : h.crdtPntTxnQty)
                                            | numberWithCommas
                                    }}
                                </div>
                            </td>
                            <td
                                class="flex content-center lg:block lg:p-2 lg:w-32 lg:text-center"
                            >
                                <div class="w-32 lg:hidden">
                                    <div class="flex justify-start">
                                        <tryhalaCoinSvg
                                            class="w-6 h-6 text-primary fill-current"
                                        />
                                        <div>
                                            {{ $t('credit.point.balance') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="font-bold lg:font-normal">
                                    <template v-if="h.crdtPntBalQty">
                                        {{ h.crdtPntBalQty | numberWithCommas }}
                                    </template>
                                    <template v-else>
                                        {{ '---' }}
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </div>
                </tbody>
            </table>

            <div class="w-full flex justify-center mt-4">
                <pager
                    class="mx-auto sm:text-sm"
                    :page="pager.page"
                    :recordsPerPage="pager.recordsPerPage"
                    :totalRecords="list.length"
                    @setPage="p => (pager.page = p)"
                />
            </div>
        </div>

        <div v-else class="w-full text-center text-2xl pt-4">
            {{ $t('credit.point.history.no.record') }}
        </div>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import spinner from '@/components/spinner.vue';
import formatDate from '@/components/formatDateFilter';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import numberWithCommas from '@/components/numberWithCommasFilter';
import contentNewLine from '@/components/contentNewLine';
import howToGetTcoinModalButton from '../../components/howToGetTcoinModalButton.vue';
import _getYear from 'date-fns/getYear';
import _getMonth from 'date-fns/getMonth';
import pager from '../../components/pager.vue';

export default {
    components: {
        breadcrumb,
        spinner,
        tryhalaCoinSvg,
        contentNewLine,
        howToGetTcoinModalButton,
        pager
    },
    filters: { formatDate, numberWithCommas },
    data() {
        return {
            loading: true,
            pager: {
                page: 1,
                recordsPerPage: 12
            }
        };
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch('getCreditPointBalance');
        await this.$store.dispatch('loadCrdtPntHistList');
        this.loading = false;
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        userFullName() {
            return `${this.user?.custFrstName || ''} ${this.user
                ?.custLastName || ''}`.trim();
        },
        list() {
            return this.$store.state.crdtPntHistList;
        },
        recordsInPage() {
            const start = (this.pager.page - 1) * this.pager.recordsPerPage;
            return this.list.slice(start, start + this.pager.recordsPerPage);
        },
        recordsInPageGroupByYearMonth() {
            let recordsInPageGroupByYearMonth = this.recordsInPage.reduce(
                (acc, c) => {
                    const year = _getYear(new Date(c.crdtPntTxnDate));
                    const month = _getMonth(new Date(c.crdtPntTxnDate));
                    const matchYearMonth = acc.find(
                        a => a.year === year && a.month === month
                    );
                    if (matchYearMonth) {
                        matchYearMonth.list.push(c);
                    } else {
                        acc.push({
                            year: year,
                            month: month,
                            list: [c]
                        });
                    }
                    return acc;
                },
                []
            );
            // sort by year and month
            recordsInPageGroupByYearMonth = recordsInPageGroupByYearMonth.sort(
                (a, b) => new Date(b.year, b.month) - new Date(a.year, a.month)
            );
            // sort sublist by crdtPntTxnDate
            recordsInPageGroupByYearMonth.forEach(
                e =>
                    (e.list = e.list.sort(
                        (a, b) =>
                            new Date(b.crdtPntTxnDate) -
                            new Date(a.crdtPntTxnDate)
                    ))
            );
            return recordsInPageGroupByYearMonth;
        },
        hasCrdtPntHist() {
            return (
                this.$store.state.crdtPntHistList &&
                this.$store.state.crdtPntHistList.length > 0
            );
        },
        crdtPntBal() {
            return this.$store.state.crdtPntBal;
        },
        enableReferral() {
            return this.$store.state.enableReferral;
        }
    }
};
</script>
